export default __webpack_public_path__ + "static/media/Collaborate.af927fe5.jpg";